/**
 * DEV-1860 (эпик DEV-1850). i18n раздела «Аналитика → Лендинги и кампании».
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей.
 *
 * Заменяет словарь под-таба «Лендинги» из «Отчётов» (DEV-1090): отчёт переехал
 * в свой раздел и оброс динамикой, структурой источников и кампаниями.
 */
export const marketingAnalyticsMessages = {
  ru: {
    common: {
      navigation: {
        analyticsMarketing: 'Лендинги и кампании',
      },
    },
    marketingAnalytics: {
      title: 'Лендинги и кампании',
      export: 'Экспорт XLSX',
      exportFailed: 'Выгрузку собрать не удалось',
      presets: {
        today: 'Сегодня',
        week: '7 дней',
        month: '30 дней',
        quarter: '90 дней',
      },
      scope: {
        all: 'Все площадки',
        allNote: 'все площадки, включая основной сайт',
        landings: 'Только лендинги',
        landingsNote: 'все лендинги, без основного сайта',
      },
      scopeLine: '{scope} · {range} ({days} дн.). Сравнение — с предыдущими {days} дн.',
      kpi: {
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        cpl: 'Стоимость заявки',
        cplHint: 'расход {value} — доля бюджета кампаний за эти дни',
        cplNoSpend: 'расход кампаний не задан',
        noViews: 'просмотров нет — конверсию не из чего считать',
        leadsExceedViews: 'заявок больше, чем просмотров: часть визитов маячок не записал',
      },
      chart: {
        title: 'Динамика по дням',
        hint: 'Столбики — просмотры (левая ось), линия — заявки (правая). Ленты под графиком: когда шла кампания.',
        views: 'просмотры',
        leads: 'заявки',
        empty: 'За период просмотров не было',
      },
      sources: {
        title: 'Структура источников',
        source: 'Источник',
        medium: 'Канал',
        untagged: 'без метки',
        hint: 'Доли считаются по заявкам. «Без метки» — переходы по неразмеченной ссылке.',
        empty: 'За период заявок с метками не было',
      },
      landings: {
        title: 'Площадки',
        hint: 'Строка выбирает площадку: весь экран пересчитается по ней. Повторный клик снимает выбор.',
        noViews: 'нет просмотров',
        leadsExceedViews: 'заявок больше просмотров',
        landing: 'Площадка',
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        site: 'Основной сайт',
        siteNote: 'vinprop.vn',
        native: 'на vinprop.vn',
        external: 'внешняя площадка',
        empty: 'За период просмотров площадок не было',
      },
      events: {
        title: 'Взаимодействия',
        scroll: 'Глубина прокрутки',
        clicks: 'Нажатия',
        submits: 'Отправок формы: {count}',
        readToEnd: 'дочитали до конца: {share}',
        empty:
          'За период взаимодействий не было. Они собираются с площадок, где стоит скрипт статистики.',
        labels: {
          unnamed: 'без метки',
          'cta-form': 'Кнопка заявки',
          phone: 'Телефон',
          email: 'Почта',
          whatsapp: 'WhatsApp',
          telegram: 'Telegram',
          zalo: 'Zalo',
        },
      },
      campaigns: {
        title: 'Кампании',
        hint: 'строка раскрывается до ссылок',
        scopedHint: 'только кампании выбранной площадки',
        leadsExceedViews: 'заявок больше просмотров',
        campaign: 'Кампания',
        target: 'Цель',
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        spend: 'Расход за период · CPL',
        unknown: 'Кампания вне списка',
        untagged: 'Без кампании',
        untaggedNote: 'переходы по неразмеченным ссылкам',
        empty: 'За период размеченных переходов не было',
      },
    },
  },
  en: {
    common: {
      navigation: {
        analyticsMarketing: 'Landings & campaigns',
      },
    },
    marketingAnalytics: {
      title: 'Landings and campaigns',
      export: 'Export XLSX',
      exportFailed: 'The export could not be built',
      presets: {
        today: 'Today',
        week: '7 days',
        month: '30 days',
        quarter: '90 days',
      },
      scope: {
        all: 'All pages',
        allNote: 'all pages, main site included',
        landings: 'Landings only',
        landingsNote: 'all landings, without the main site',
      },
      scopeLine: '{scope} · {range} ({days}d). Compared with the previous {days} days.',
      kpi: {
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        cpl: 'Cost per lead',
        cplHint: 'spend {value} — the share of campaign budgets for these days',
        cplNoSpend: 'campaign spend not set',
        noViews: 'no views — nothing to divide by',
        leadsExceedViews: 'more leads than views: some visits were not recorded by the beacon',
      },
      chart: {
        title: 'Daily dynamics',
        hint: 'Bars are views (left axis), the line is leads (right). Ribbons below show when a campaign ran.',
        views: 'views',
        leads: 'leads',
        empty: 'No views in this period',
      },
      sources: {
        title: 'Source mix',
        source: 'Source',
        medium: 'Medium',
        untagged: 'untagged',
        hint: 'Shares are counted by leads. “Untagged” means visits through links without tags.',
        empty: 'No tagged leads in this period',
      },
      landings: {
        title: 'Landings',
        hint: 'A row picks a page: the whole screen is recounted for it. Click again to clear.',
        noViews: 'no views',
        leadsExceedViews: 'more leads than views',
        landing: 'Landing',
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        site: 'Main site',
        siteNote: 'vinprop.vn',
        native: 'on vinprop.vn',
        external: 'external site',
        empty: 'No landing views in this period',
      },
      events: {
        title: 'Interactions',
        scroll: 'Scroll depth',
        clicks: 'Taps',
        submits: 'Form submissions: {count}',
        readToEnd: 'read to the end: {share}',
        empty:
          'No interactions in this period. They come from pages that carry the metrics script.',
        labels: {
          unnamed: 'unlabelled',
          'cta-form': 'Request button',
          phone: 'Phone',
          email: 'Email',
          whatsapp: 'WhatsApp',
          telegram: 'Telegram',
          zalo: 'Zalo',
        },
      },
      campaigns: {
        title: 'Campaigns',
        hint: 'a row expands into its links',
        scopedHint: 'campaigns of the selected page only',
        leadsExceedViews: 'more leads than views',
        campaign: 'Campaign',
        target: 'Target',
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        spend: 'Spend in period · CPL',
        unknown: 'Campaign outside the list',
        untagged: 'No campaign',
        untaggedNote: 'visits through untagged links',
        empty: 'No tagged visits in this period',
      },
    },
  },
  vn: {
    common: {
      navigation: {
        analyticsMarketing: 'Trang đích và chiến dịch',
      },
    },
    marketingAnalytics: {
      title: 'Trang đích và chiến dịch',
      export: 'Xuất XLSX',
      exportFailed: 'Không tạo được tệp xuất',
      presets: {
        today: 'Hôm nay',
        week: '7 ngày',
        month: '30 ngày',
        quarter: '90 ngày',
      },
      scope: {
        all: 'Tất cả trang',
        allNote: 'tất cả trang, gồm cả trang chính',
        landings: 'Chỉ landing',
        landingsNote: 'tất cả landing, không tính trang chính',
      },
      scopeLine: '{scope} · {range} ({days} ngày). So với {days} ngày trước đó.',
      kpi: {
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        cpl: 'Giá mỗi yêu cầu',
        cplHint: 'chi phí {value} — phần ngân sách chiến dịch cho những ngày này',
        noViews: 'không có lượt xem — không có gì để chia',
        leadsExceedViews: 'yêu cầu nhiều hơn lượt xem: một phần lượt truy cập chưa được ghi nhận',
        cplNoSpend: 'chưa nhập chi phí chiến dịch',
      },
      chart: {
        title: 'Diễn biến theo ngày',
        hint: 'Cột là lượt xem (trục trái), đường là yêu cầu (trục phải). Dải bên dưới: khi chiến dịch chạy.',
        views: 'lượt xem',
        leads: 'yêu cầu',
        empty: 'Kỳ này không có lượt xem',
      },
      sources: {
        title: 'Cơ cấu nguồn',
        source: 'Nguồn',
        medium: 'Kênh',
        untagged: 'không thẻ',
        hint: 'Tỷ trọng tính theo yêu cầu. «Không thẻ» là lượt vào qua liên kết chưa gắn thẻ.',
        empty: 'Kỳ này không có yêu cầu gắn thẻ',
      },
      landings: {
        title: 'Trang đích',
        hint: 'Nhấn vào dòng để chọn trang: toàn màn hình sẽ tính lại theo trang đó. Nhấn lại để bỏ chọn.',
        noViews: 'không có lượt xem',
        leadsExceedViews: 'yêu cầu nhiều hơn lượt xem',
        landing: 'Trang đích',
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        site: 'Trang chính',
        siteNote: 'vinprop.vn',
        native: 'trên vinprop.vn',
        external: 'trang bên ngoài',
        empty: 'Kỳ này không có lượt xem trang đích',
      },
      events: {
        title: 'Tương tác',
        scroll: 'Độ sâu cuộn trang',
        clicks: 'Lượt nhấn',
        submits: 'Lượt gửi biểu mẫu: {count}',
        readToEnd: 'đọc hết trang: {share}',
        empty:
          'Kỳ này không có tương tác. Chúng được thu thập từ các trang có gắn tập lệnh thống kê.',
        labels: {
          unnamed: 'không nhãn',
          'cta-form': 'Nút gửi yêu cầu',
          phone: 'Điện thoại',
          email: 'Email',
          whatsapp: 'WhatsApp',
          telegram: 'Telegram',
          zalo: 'Zalo',
        },
      },
      campaigns: {
        title: 'Chiến dịch',
        hint: 'nhấn vào dòng để xem các liên kết',
        scopedHint: 'chỉ các chiến dịch của trang đã chọn',
        leadsExceedViews: 'yêu cầu nhiều hơn lượt xem',
        campaign: 'Chiến dịch',
        target: 'Đích đến',
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        spend: 'Chi phí trong kỳ · CPL',
        unknown: 'Chiến dịch ngoài danh sách',
        untagged: 'Không có chiến dịch',
        untaggedNote: 'lượt truy cập qua liên kết không gắn thẻ',
        empty: 'Kỳ này không có lượt vào gắn thẻ',
      },
    },
  },
}
